export default {
  storeTo: 'Entrepôt vers',
  weightHaveUnit: 'Poids (g)',
  productType: 'Type de produit',
  long: 'Longueur (cm)',
  width: 'Largeur (cm)',
  height: 'Hauteur (cm)',
  seeDetail: 'Voir les détails',
  queryTips: 'Veuillez saisir les paramètres correspondants pour vérifier le fret !',
  carrier: 'Transporteur',
  carrierCode: 'Code transporteur',
  product: 'Produit',
  productCode: 'Code produit',
  totalfee: 'Coût total',
  billingWeight: 'Poids facturé',
  feeEstimation: 'Estimation des coûts',
  postFeeEstimation: "Estimation de l'expédition",
  postFee: "Frais d'expédition",
  postTime: 'Délai de livraison estimé',
  packUp: 'Réduire',
  startWeight: 'Poids de départ',
  endWeight: 'Poids final',
  calcExpression: 'Expression de calcul',
  baseFreight: 'Fret de base',
  registrationFee: "Frais d'inscription",
  noSend: 'Produits non disponibles',
  canSend: 'Produits disponibles',
  priceFrom: 'Composition du coût',
  itemLimit: "Limite d'articles",
  disReason: "Motif d'indisponibilité",
  BasicFreight: 'Fret de base',
  OperationFreight: 'Frais de douane et de déclaration',
  RegistrationFreight: "Frais d'inscription",
  IossFee: 'Frais IOSS',
  TariffFreight: 'Droits de douane',
  VATFregith: 'Taxe sur la Valeur Ajoutée (TVA)',
  AserviceFee: 'Frais de service supplémentaires',
  ExtraSizeFreight: 'Surtaxe pour taille hors format',
  AdditionalDeliveryFeeForFemoteAreas:
    'Frais de livraison supplémentaires pour les zones éloignées',
  FuelSurcharge: 'Surtaxe carburant',
  zoneCode: 'Zone',
  amount: 'Prix',
  rate: 'Taux',
  conditionExpression: 'Calcul',
  feeFactor: 'Facteur de frais',
  continuedPrice: 'Prix du poids supplémentaire',
  continuedWeight: 'Poids supplémentaire (g)',
  firstPrice: 'Prix du premier poids',
  firstWeight: 'Premier poids (g)',
  weightRangeStart: 'Poids de départ (g)',
  weightRangeEnd: 'Poids final (g)',
  holder: {
    toCountry: 'Choisir la destination',
    inputWeight: 'Veuillez saisir le poids',
    selectCountry: 'Veuillez sélectionner un pays',
    selectCarrier: 'Veuillez sélectionner un transporteur/ligne de transport/pays de destination',
    selectCategory: "Choisir la restriction d'envoi",
  },
  typeDelivery: 'Types de livraison',
  shippingTime: 'Délai de livraison estimé',
  workDay: 'jours ouvrables',
  deliveryTips: 'Conseils de livraison',
  estimatedShippingFee: "Frais d'expédition estimés",
  lineServiceTips:
    "Remarque : Tous les services logistiques pour les itinéraires non exploités en propre par acbuy sont fournis par des prestataires logistiques tiers, qui ajusteront les prix du fret en fonction des conditions du marché. En cas de changement de prix, acbuy vous en informera à l'avance. Si vous rencontrez des problèmes avec les services logistiques, acbuy peut communiquer avec le prestataire logistique tiers en votre nom.",
  logisticsStatement: '<Déclaration de service logistique>',
  customizedDelivery: 'Service de livraison personnalisé',
  customizedDeliveryText:
    'Livraison de marchandises en vrac, transport maritime et ferroviaire, vous pouvez choisir un service de livraison personnalisé',
  customizeNow: 'Personnaliser maintenant',
  declareAmountRange: 'Plage du montant de la déclaration',
  viewUnavailableLines: 'Afficher les lignes non disponibles (non disponibles :',
  'i18n-0000001': 'Taux de livraison',
  'i18n-0000002':
    'Pour tous les colis expédiés entre le {startTime} et le {endTime}, le pourcentage de colis qui ont été livrés à ce jour',
  'i18n-0000003': 'jours',
  couponDiscount: 'Réduction du coupon',
  expectedDiscount: 'Remise prévue',
}
